export enum ApiErrorCodes {
  NO_LECTURER_IN_LECTURE,
  CAN_NOT_DELETE_POPULATED_EXAM,
  SETTINGS_ABSTRACT_PROGRAM_CAN_NOT_BE_DELETED,
  COURSE_IS_NOT_EMPTY,
  SETTINGS_ABSTRACT_COURSE_HAS_USE_IN_ABSTRACT_PROGRAM,
  SETTINGS_SUPERVISORY_INSTITUTION_ATTACH_TO_PROGRAM,
  SETTINGS_EXAM_TYPE_HAS_USAGES,
  SETTINGS_PAYMENT_SERVICE_TYPE_HAS_USAGES,
  PAYMENT_SERVICE_HAS_ALLOCATIONS,
  NOT_VALID_RATE_REQUIREMENT,
  LECTURES_HAS_USAGE,
  DELETE_STUDENT_FROM_COURSE_HAS_USAGE,
  COMPLETE_LECTURE_INVALID_TIME_RANGE,
  COURSE_POINTS_OVER_HUNDRED,
  DELETE_LECTURER_FROM_COURSE_HAS_LECTURES,
  SETTINGS_CLASS_HAS_LECTURES,
  COURSE_CAPACITY_EXCEEDED,
  PAYMENT_SERVICE_ALREADY_PAID,
  SETTINGS_ASSIGNMENT_TYPE_LINK_TO_COURSE_ASSIGNMENT,
  SETTINGS_BRANCH_LINK_TO_BUILDINGS,
  SETTINGS_BRANCH_LINK_TO_PROGRAMS,
  SETTINGS_BRANCH_LINK_TO_COURSES,
  CALENDAR_INVALID_ITERATION_NUMBER,
  USER_NO_BRANCH_PERMISSIONS,
  PASSWORD_CHANGE_REQUIRED,
  SETTINGS_MAJOR_ATTACHED_TO_ABSTRACT_PROGRAM,
  ASSIGNMENT_HAS_STUDENT_DATA,
  SETTINGS_STUDENTS_STATUSES_HAS_USAGES,
  SETTING_MAJOR_ATTACHED_TO_ABSTRACT_COURSE,
  USER_WITH_NATIONAL_ID_ALREADY_EXISTS,
  FINISH_LECTURE_NO_LECTURE_NAME,
  FINISH_LECTURE_NO_ATTENDANCE,
  EXTERNAL_EXAM_PAYMENT_REQUIRED,
  SETTINGS_EXTERNAL_EXAM_HAS_USAGES,
  EXTERNAL_EXAM_GROUP_HAS_REGISTERED_STUDENTS,
  EXTERNAL_EXAM_GROUP_HAS_PAID_STUDENTS,
  EXTERNAL_EXAM_STUDENT_IS_register,
  COURSE_POLL_HAS_SUBMISSIONS,
  SETTINGS_ABSTRACT_POLL_HAS_USAGES,
  SETTINGS_ABSTRACT_POLL_QUESTION_HAS_USAGES,
  SETTINGS_ABSTRACT_POLL_QUESTION_OPTION_HAS_USAGES,
  INSTALLMENT_PLAN_HAS_NON_PENDING_INSTALLMENTS,
  INSTALLMENT_PLAN_NO_PENDING_INSTALLMENTS,
  INSTALLMENT_NOT_FOUND,
  INSTALLMENT_ALREADY_PROCESSED,
  PELECARD_INTERNAL_ERROR,
  PELECARD_BLOCK_CARD,
  PELECARD_STOLEN_CARD,
  PELECARD_REQUEST_CALL_SUPPORT,
  PELECARD_REFUSAL,
  PELECARD_FAKE_BAN_CARD,
  PELECARD_WRONG_ID_OR_CVV,
  PELECARD_CARD_EXPIRED,
  PELECARD_COMMUNICATION_ERROR,
  PELECARD_GENERAL_ERROR,
  ABSTRACT_COURSE_HAS_COURSE_IMPLEMENTATION,
  STUDENT_SCHOLARSHIP_HAS_PAYMENTS,
  PAYMENT_SERVICE_ALLOCATION_ALREADY_PAID,
  CAN_NOT_DELETE_ALLOCATION_COMING_FROM_PROGRAM,
  CRM_ACCOUNT_HAS_USAGES,
  INSTALLMENT_PLAN_REDUCE_AMOUNT_EXCEEDS_REMAINING_PENDING_AMOUNT,
  INSTALLMENT_REDUCE_AMOUNT_EXCEEDS_INSTALLMENT_AMOUNT,
  INSTALLMENT_BANK_TRANSFER_NOT_PAID,
  INSTALLMENT_BANK_TRANSFER_NO_USER_PAYMENT,
  STANDING_ORDER_BANK_TRANSFER_CANCEL_REASON_NOT_FOUND,
  MISSING_CHART_OF_ACCOUNTS_FOR_PAYMENT,
  CHART_OF_ACCOUNTS_NO_BRANCH_ALREADY_EXISTS_FOR_TYPE,
  LECTURER_HAS_SCHEDULE_OVERLAP,
  CHECK_BOUNCED_BEFORE_DEPOSIT,
  DEPOSIT_PAYMENT_JOURNAL_ALREADY_EXPORTED,
  DEPOSIT_IS_LOCKED,
  JOURNAL_ENTRY_DAT_INVALID_LINES,
  JOURNAL_ENTRY_DAT_MISSING_REQUIRED_DATA,
  ACCOUNTING_DOCUMENTS_PDF_MERGE_LIMIT_EXCEEDED,
  UPDATE_LECTURE_NOT_ALLOWED_INVALID_STATUS,
  WORKING_HOUR_SALARY_ALREADY_PAID,
  PERMISSION_DENIED,
  WORKING_HOUR_EXCEEDS_LECTURE_SCHEDULE,
}

export const displayErrorText = (err: ApiErrorCodes) => {
  switch (err) {
    case ApiErrorCodes.NO_LECTURER_IN_LECTURE:
      return '';
    case ApiErrorCodes.CAN_NOT_DELETE_POPULATED_EXAM:
      return 'לא ניתן למחוק מבחן עם הרשמות ושיבוצים לכיתות';

    case ApiErrorCodes.SETTINGS_ABSTRACT_PROGRAM_CAN_NOT_BE_DELETED:
      return 'לא ניתן להסיר תוכנית טיפוסית בעלת מופעים';
    case ApiErrorCodes.COURSE_IS_NOT_EMPTY:
      return 'לא ניתן לשנות תוכן בקורס מאוכלס';

    case ApiErrorCodes.SETTINGS_ABSTRACT_COURSE_HAS_USE_IN_ABSTRACT_PROGRAM:
      return 'לא ניתן למחוק קורס המשוייך לתוכנית';

    case ApiErrorCodes.SETTINGS_SUPERVISORY_INSTITUTION_ATTACH_TO_PROGRAM:
      return 'לא ניתן למחוק גוף מפקח המשוייך לתוכנית';

    case ApiErrorCodes.SETTINGS_EXAM_TYPE_HAS_USAGES:
      return 'לא ניתן למחוק סוג מבחן הנמצא בשימוש';

    case ApiErrorCodes.PAYMENT_SERVICE_HAS_ALLOCATIONS:
      return 'לא ניתן למחוק את שרות התשלום אחרי ביצוע חיוב לסטודנט';
    case ApiErrorCodes.COURSE_POINTS_OVER_HUNDRED:
      return 'סכום ניקוד המטלות והמבחנים לא יכל לעלות על 100';
    case ApiErrorCodes.DELETE_LECTURER_FROM_COURSE_HAS_LECTURES:
      return 'לא ניתן להסיר מרצה שיש לו הרצאות בקורס';
    case ApiErrorCodes.SETTINGS_CLASS_HAS_LECTURES:
      return 'לא ניתן למחוק כיתה שמשובצות בה הרצאות';

    case ApiErrorCodes.NOT_VALID_RATE_REQUIREMENT:
      return 'לא נמצא תעריף מתאים לנתונים המבוקשים';

    case ApiErrorCodes.COURSE_CAPACITY_EXCEEDED:
      return 'לא קיימת מכסת שעות, ניתן לבקש מכסת שעות בדף הבית של הקורס';

    case ApiErrorCodes.PAYMENT_SERVICE_ALREADY_PAID:
      return 'לא ניתן למחוק שרות תשלום ששולם ע״י סטודנט אחד לפחות';

    case ApiErrorCodes.SETTINGS_ASSIGNMENT_TYPE_LINK_TO_COURSE_ASSIGNMENT:
      return 'לא ניתן למחוק סוג מטלה המקושרת למטלה קיימת';
    case ApiErrorCodes.SETTINGS_BRANCH_LINK_TO_BUILDINGS:
      return 'לא ניתן למחוק שלוחה המקושרת למבנה';

    case ApiErrorCodes.SETTINGS_BRANCH_LINK_TO_PROGRAMS:
      return 'לא ניתן למחוק שלוחה עם תוכניות';

    case ApiErrorCodes.SETTINGS_BRANCH_LINK_TO_COURSES:
      return 'לא ניתן למחוק שלוחה עם קורסים';

    case ApiErrorCodes.CALENDAR_INVALID_ITERATION_NUMBER:
      return 'לא ניתן ליצור מקבץ שיבוצים עם יותר מ 16 מפגשים כמקשה אחת';

    case ApiErrorCodes.USER_NO_BRANCH_PERMISSIONS:
      return 'לא קיימת הרשאה לשלוחות המבוקשות, אנה פנה למנהל המערכת';

    case ApiErrorCodes.PASSWORD_CHANGE_REQUIRED:
      return 'נדרש לשנות את הסיסמא על מנת להמשיך';

    case ApiErrorCodes.SETTINGS_MAJOR_ATTACHED_TO_ABSTRACT_PROGRAM:
      return 'לא ניתן למחוק מגמה המקושרת לתוכנית טיפוסית';

    case ApiErrorCodes.ASSIGNMENT_HAS_STUDENT_DATA:
      return 'לא ניתן למחוק מטלה שהוגשה על ידי סטודנט ו/או ניתן ציון לסטודנט';

    case ApiErrorCodes.SETTINGS_STUDENTS_STATUSES_HAS_USAGES:
      return 'לא ניתן למחוק סטטוס סטודנט בקורס הנמצא בשימוש';

    case ApiErrorCodes.SETTING_MAJOR_ATTACHED_TO_ABSTRACT_COURSE:
      return 'לא ניתן למחוק מגמה המקושרת לקורס טיפוסי';

    case ApiErrorCodes.SETTINGS_PAYMENT_SERVICE_TYPE_HAS_USAGES:
      return 'לא ניתן למחוק סוג שרות תשלום המשוייך לשרות תשלום';

    case ApiErrorCodes.USER_WITH_NATIONAL_ID_ALREADY_EXISTS:
      return 'משתמש בעל ת.ז זו קיים במערכת, אם אינך מוצא אותו יתכן והוא משוייך לשלוחה אחרת. ניתן לפנות למנהל מערכת על מנת להסדיר את העניין';

    case ApiErrorCodes.FINISH_LECTURE_NO_LECTURE_NAME:
      return 'לא ניתן לסגור הרצאה ללא שם הרצאה';

    case ApiErrorCodes.FINISH_LECTURE_NO_ATTENDANCE:
      return 'לא ניתן לסגור הרצאה ללא הזנת נוכחות';

    case ApiErrorCodes.EXTERNAL_EXAM_PAYMENT_REQUIRED:
      return 'נדרש תשלום לפני הרשמה למבחן';

    case ApiErrorCodes.SETTINGS_EXTERNAL_EXAM_HAS_USAGES:
      return 'למבחן חיצוני טיפוסי זה קימים שימושים, יש להסיר את השימושים או ליצור מבחן טיפוסי חדש';

    case ApiErrorCodes.EXTERNAL_EXAM_GROUP_HAS_REGISTERED_STUDENTS:
      return 'לא ניתן למחוק מקבץ עם סטודנטים רשומים לאחד מהמבחנים במקבץ';

    case ApiErrorCodes.EXTERNAL_EXAM_GROUP_HAS_PAID_STUDENTS:
      return 'לא ניתן למחוק מקבץ עם תשלומים שבוצעו לאחד מהמבחנים במקבץ';

    case ApiErrorCodes.EXTERNAL_EXAM_STUDENT_IS_register:
      return 'לא ניתן לבצע עדכון זה עבור סטודנט שרשום, יש לבטל את הההרשמה לפני ביצוע עדכון זה';

    case ApiErrorCodes.COURSE_POLL_HAS_SUBMISSIONS:
      return 'לא ניתן למחוק משוב שסטודנטים ענו עליו';

    case ApiErrorCodes.SETTINGS_ABSTRACT_POLL_HAS_USAGES:
    case ApiErrorCodes.SETTINGS_ABSTRACT_POLL_QUESTION_HAS_USAGES:
    case ApiErrorCodes.SETTINGS_ABSTRACT_POLL_QUESTION_OPTION_HAS_USAGES:
      return 'לא ניתן למחוק משוב שסטודנטים ענו עליו';

    case ApiErrorCodes.INSTALLMENT_PLAN_HAS_NON_PENDING_INSTALLMENTS:
      return 'לא ניתן למחוק שירות תשלום עם שירותי תשלום אחרי ביצוע ניסיון תשלום';

    case ApiErrorCodes.INSTALLMENT_PLAN_NO_PENDING_INSTALLMENTS:
      return 'לא נותרו תשלומים ממתינים להוספה, ניתן ליצור הוראת קבע נוספת או לבחור באמצעי תשלום אחר';

    case ApiErrorCodes.PELECARD_INTERNAL_ERROR:
      return 'שגיאה פנימית בחברת הסליקה, יש לפנות לחברת הסליקה פלאקארד';

    case ApiErrorCodes.PELECARD_BLOCK_CARD:
      return 'הכרטיס חסום, יש לפנות לחברת האשראי';

    case ApiErrorCodes.PELECARD_STOLEN_CARD:
      return 'הכרטיס דווח כגנוב, יש לפנות לחברת האשראי';

    case ApiErrorCodes.PELECARD_REQUEST_CALL_SUPPORT:
      return 'נדרשת התקשרות לחברת האשראי לאישור העסקה';

    case ApiErrorCodes.PELECARD_REFUSAL:
      return 'העסקה נדחתה על ידי חברת האשראי';

    case ApiErrorCodes.PELECARD_FAKE_BAN_CARD:
      return 'הכרטיס חסום או לא תקין';

    case ApiErrorCodes.PELECARD_WRONG_ID_OR_CVV:
      return 'מספר תעודת זהות או קוד CVV שגוי';

    case ApiErrorCodes.PELECARD_CARD_EXPIRED:
      return 'תוקף הכרטיס פג';

    case ApiErrorCodes.PELECARD_COMMUNICATION_ERROR:
      return 'שגיאת תקשורת עם חברת הסליקה, יש לנסות שוב';

    case ApiErrorCodes.PELECARD_GENERAL_ERROR:
      return 'שגיאה כללית בעיבוד התשלום, יש לנסות שוב או לפנות לתמיכה';

    case ApiErrorCodes.ABSTRACT_COURSE_HAS_COURSE_IMPLEMENTATION:
      return 'לא ניתן למחוק קורס טיפוסי עם קורס מקושר';

    case ApiErrorCodes.STUDENT_SCHOLARSHIP_HAS_PAYMENTS:
      return 'לא ניתן למחוק מלגה ששולמו באמצעותה';

    case ApiErrorCodes.PAYMENT_SERVICE_ALLOCATION_ALREADY_PAID:
      return 'לא ניתן למחוק שירות תשלום ששולם באופן חלקי/מלא';

    case ApiErrorCodes.CAN_NOT_DELETE_ALLOCATION_COMING_FROM_PROGRAM:
      return 'לא ניתן למחוק שירות תשלום המגיע מתוכנית לימודים';

    case ApiErrorCodes.CRM_ACCOUNT_HAS_USAGES:
      return 'לא ניתן חשבון המכיל אנשי, קשר, חשבונות, תשלומים ועוד...';

    case ApiErrorCodes.MISSING_CHART_OF_ACCOUNTS_FOR_PAYMENT:
      return 'לא קיים חשבון מתאים בהנהלת חשבונות, יש לפנות למנהל/ת חשובנות';

    case ApiErrorCodes.CHART_OF_ACCOUNTS_NO_BRANCH_ALREADY_EXISTS_FOR_TYPE:
      return 'לא ניתן ליצור שני חשבונות ללא שלוחה עם אותו אמצעי תשלום';

    case ApiErrorCodes.LECTURER_HAS_SCHEDULE_OVERLAP:
      return 'יש לשבץ מרצה פנוי';

    case ApiErrorCodes.CHECK_BOUNCED_BEFORE_DEPOSIT:
      return 'המחאה זו אינה הופדה';

    case ApiErrorCodes.UPDATE_LECTURE_NOT_ALLOWED_INVALID_STATUS:
      return 'אופס, ההרצאה כבר התחילה';

    case ApiErrorCodes.WORKING_HOUR_SALARY_ALREADY_PAID:
      return 'אופס, לא ניתן לשנות שעות ששולמו';

    case ApiErrorCodes.PERMISSION_DENIED:
      return 'אין לך הרשאה לביצוע פעולה זו';

    case ApiErrorCodes.WORKING_HOUR_EXCEEDS_LECTURE_SCHEDULE:
      return 'לא ניתן לעדכן שעות עבודה בשעות חורגות';
  }
};
